import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString } from '../utils'

export const ContextVacation = React.createContext<any>({})


export default function ContextVacationModels(props: any) {
    const [jsonParmsVacation, setJsonParmsVacation] = useState<any>({ 'from': getDateNow(), 'to': getDateNow() , 'page':1 , 'user':[] })
    const [activeFilterVacation, setActiveFilterVacation] = useState<any>({
        'activePeriod': -1 ,
        'type':-1 ,
        'status':-1 ,
        'user':[],
        'startCalender':convertDateToString(getDateNow()) ,
        'endCalender':convertDateToString(getDateNow()) ,
    })




    return (
        <ContextVacation.Provider value={{
            activeFilterVacation,
            setActiveFilterVacation ,
            jsonParmsVacation ,
            setJsonParmsVacation
        }}>
            {props.children}
        </ContextVacation.Provider>
    )
}